import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeHouseholdSetupDataAccessStoreModule } from '@se-po/se-household-setup-data-access-store'
import { SharedFeatureHouseholdInviteModule } from '@se-po/shared-feature-household-invite'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'
import { GuardianInviteComponent } from './guardian-invite/guardian-invite.component'

@NgModule({
  imports: [
    CommonModule,
    SeHouseholdSetupDataAccessStoreModule,
    SharedFeatureHouseholdInviteModule,
    SharedUiSetupBarModule
  ],
  declarations: [GuardianInviteComponent],
  exports: [GuardianInviteComponent],
})
export class SeHouseholdSetupFeatureInviteModule {}
